module.exports = __webpack_public_path__ + "static/media/code.f060d661.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/web/code.svg
// module id = 260
// module chunks = 0